import React from 'react';
import RectangularSkeletonLoader, { SkeletonLoaderProps } from './RectangularSkeletonLoader';

export default function SquaredSkeletonLoader(props: Readonly<SkeletonLoaderProps>) {
  const { viewBox, height, width, y, rx, ry } = props;

  const overrideProps = {
    ...props,
    viewBox: viewBox ?? '0 0 50 50',
    height: height ?? '22.5',
    width: width ?? '22.5',
    y: y ?? '17.5',
    rx: rx ?? '3',
    ry: ry ?? '3'
  };

  return <RectangularSkeletonLoader {...overrideProps} />;
}
